module.exports = __webpack_public_path__ + "37a27c0ec85148650604042a54646efc.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Mission/images/img_mission_value01.svg
// module id = 1270
// module chunks = 7